import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { CookiesProvider } from 'react-cookie';
import Donation from './index';
import LangProvider from '../components/LangProvider';

export default (selector, props) => {
  const render = (Component) => {
    ReactDOM.render(
      <AppContainer>
        <CookiesProvider>
          <LangProvider>
            <Component initProps={props} />
          </LangProvider>
        </CookiesProvider>
      </AppContainer>,
      document.querySelector(selector),
    );
  };

  render(Donation);

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./index', () => {
      // eslint-disable-next-line global-require
      const NextComponent = require('./index').default;
      render(NextComponent);
    });
  }
};



// WEBPACK FOOTER //
// ./app/Assets/js/features/donation/renderInto.js